import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { RELATIONSHIP_ROLE_COMPATIBILITY_OPTIONS } from '@/pages/Onboarding/options/RelationshipRoleCompatibility/RELATIONSHIP_ROLE_COMPATIBILITY_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenRelationshipRole: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'RelationshipRole',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const relationshipRole = form.watch('relationship_role');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['relationship_role']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        relationshipRole: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const handleBack = () => {
    wizard.goToStep('most_intimate_moment');
  };

  return (
    <OnboardingPage background={'dark-solid'}>
      <OnboardingNavigation onBack={handleBack} />

      <IonContent>
        <OwnAiTitle>What role do you play in a relationship?</OwnAiTitle>
        <OnboardingOptionsList>
          {RELATIONSHIP_ROLE_COMPATIBILITY_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={relationshipRole === option.id}
              control={form.control}
              option={option}
              name="relationship_role"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`relationship-role-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
